export function getWindowParam(param: string) {
  return getParam(param, window.location);
}

function getParam(param: string, url: URL | Location): string | undefined {
  return new URLSearchParams(url.search).get(param) ?? undefined;
}
